export const CHECK_ACCESS = "CHECK_ACCESS";
export const CHECK_ACCESS_SUCCESS = "CHECK_ACCESS_SUCCESS";
export const CHECK_ACCESS_ERROR = "CHECK_ACCESS_ERROR";
export const ACCESS_DENIED = "ACCESS_DENIED";
export const DISMISS_MESSAGE = "DISMISS_MESSAGE";
export const SAVE_URLS_PARAMS = "SAVE_URLS_PARAMS";
export const SAVE_PATIENT_DETAILS = "SAVE_PATIENT_DETAILS";
export const SAVE_CONSULT_NOTE_VISIBILITY = "SAVE_CONSULT_NOTE_VISIBILITY";
export const UPDATE_EBS_NUMBER = "UPDATE_EBS_NUMBER";
export const SET_REDO_ERX_LIST = "SET_REDO_ERX_LIST";
export const IS_PATIENT_ONLINE = "IS_PATIENT_ONLINE";
export const SAVE_APPOINTMENT_ID = "SAVE_APPOINTMENT_ID";
export const SET_IS_PBS_AUTHORITY_REQUIRED = "SET_IS_PBS_AUTHORITY_REQUIRED";
export const SET_IS_RE_AUTHENTICATION_REQUIRED =
  "SET_IS_RE_AUTHENTICATION_REQUIRED";
export const SET_PRESCRIBING_MESSAGE = "SET_PRESCRIBING_MESSAGE";
